export const displayText = (paymentMethod) => {
  switch (paymentMethod) {
    case "card":
      return "Cards (credit, debit, pre-paid)"
    case "us_bank_account":
      return "Bank Accounts (ACH)"
  }
}

// Returns the full class string, family included: the kit holds no bank glyph,
// so ACH comes from Classic under its canonical name (fa-bank is an alias).
export const iconClass = (paymentMethod) => {
  switch (paymentMethod) {
    case "card":
      return "fa-kit fa-md-credit-card"
    case "us_bank_account":
      return "fa-solid fa-building-columns"
  }
}
